/**
 * Console account password rule shared by web and server:
 * 8-15 chars, must contain uppercase + lowercase + digit,
 * printable ASCII special symbols allowed (no spaces).
 */
export const CONSOLE_PASSWORD_MIN_LENGTH = 8
export const CONSOLE_PASSWORD_MAX_LENGTH = 15
export const CONSOLE_PASSWORD_RULE_MESSAGE = '密码需为 8-15 位，同时包含大写字母、小写字母和数字，可包含特殊符号'

export function isValidConsolePassword(value: string): boolean {
  if (value.length < CONSOLE_PASSWORD_MIN_LENGTH || value.length > CONSOLE_PASSWORD_MAX_LENGTH) return false
  if (!/[a-z]/.test(value)) return false
  if (!/[A-Z]/.test(value)) return false
  if (!/\d/.test(value)) return false
  // printable ASCII only — rejects spaces and control/multibyte chars
  return /^[\x21-\x7e]+$/.test(value)
}
